import { render, staticRenderFns } from "./LotteryItem.vue?vue&type=template&id=48f71985&"
import script from "./LotteryItem.vue?vue&type=script&lang=js&"
export * from "./LotteryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports